import { useState } from 'react'

import type { Field } from 'factorial-form'

import plans from 'modules/billing/store/collections/plans'
import type Plan from 'modules/billing/store/models/Plan'
import type { Families } from 'modules/billing/store/models/Plan'

interface Props {
  plan: Plan | undefined | null
  family: Families
}
interface ReturnType {
  onChangePricingPeriod: (field: Field) => void
  upgradePlan: Plan | undefined | null
}

const useUpgradePlan = ({ plan, family }: Props): ReturnType => {
  const [upgradePlan, setPlan] = useState<Plan | undefined | null>(plan)

  const onChangePricingPeriod = (field: Field) => {
    setPlan(
      plans.find({
        family,
        interval: field.value,
      })
    )
  }

  return {
    upgradePlan,
    onChangePricingPeriod,
  }
}

export default useUpgradePlan
